"use client";

import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import appleLogo from "@/assets/images/footer/apple-store2.svg";
import playStoreLogo from "@/assets/images/footer/play-store2.svg";
import {
  KROOLO_APP_STORE_URL,
  KROOLO_PLAY_STORE_URL,
} from "@/utils/app-store-links";

type Platform = "ios" | "android" | null;

const detectPlatform = (): Platform => {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent || navigator.vendor || "";
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";
  if (/android/i.test(ua)) return "android";
  return null;
};

const StoreBadges = ({
  size = "default",
}: {
  size?: "default" | "large";
}) => {
  const [platform, setPlatform] = useState<Platform>(null);

  useEffect(() => {
    setPlatform(detectPlatform());
  }, []);

  const badgeClass = "transition-transform hover:scale-[1.02]";
  const imageWidth = size === "large" ? 160 : 140;
  const imageHeight = size === "large" ? 48 : 42;

  return (
    <div className="flex flex-wrap items-center justify-center gap-4">
      <Link
        href={KROOLO_APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`relative ${badgeClass} ${platform === "ios" ? "rounded-xl ring-2 ring-[#6049E7] ring-offset-2" : ""
          }`}
        aria-label="Download Kroolo on the App Store"
      >
        {platform === "ios" && (
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#6049E7] px-2.5 py-0.5 text-[10px] font-semibold text-white">
            Recommended
          </span>
        )}
        <Image
          src={appleLogo}
          alt="Download on the App Store"
          width={imageWidth}
          height={imageHeight}
        />
      </Link>
      <Link
        href={KROOLO_PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`relative ${badgeClass} ${platform === "android"
            ? "rounded-xl ring-2 ring-[#6049E7] ring-offset-2"
            : ""
          }`}
        aria-label="Get Kroolo on Google Play"
      >
        {platform === "android" && (
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#6049E7] px-2.5 py-0.5 text-[10px] font-semibold text-white">
            Recommended
          </span>
        )}
        <Image
          src={playStoreLogo}
          alt="Get it on Google Play"
          width={imageWidth}
          height={imageHeight}
        />
      </Link>
    </div>
  );
};

export default StoreBadges;
